export default __webpack_public_path__ + "static/tag-dont-4-dark-b2a5a2cfe0629574a1e61bf96cae0a115e1d38aa8f7d566bceb80796bcdd96e7.png";